var map = {
	"./computer/Block/BlockDetail.vue": [
		"09f3",
		"chunk-55a8c964"
	],
	"./mobile/Block/BlockDetail.vue": [
		"0dc0",
		"chunk-54cea6f2"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4649";
module.exports = webpackAsyncContext;